var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createServerSideHelpers } from '@trpc/react-query/server';
import { ServerSidePropsContext } from 'root/src/client/v2/common/helpers/gsspHelpers';
import { createTRPCClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';
import { getTRPCUrl } from 'root/src/client/v2/trpc/trpc';
export function getTRPCServerSideHelpers(context) {
    return __awaiter(this, void 0, void 0, function* () {
        const gsspHelper = new ServerSidePropsContext(context);
        const proxyClient = createTRPCClient({
            links: [
                httpBatchLink({
                    transformer: superjson,
                    url: getTRPCUrl(),
                    headers: {
                        Authorization: `Bearer ${gsspHelper.getAuthToken()}`,
                    },
                }),
            ],
        });
        return createServerSideHelpers({
            client: proxyClient,
            transformer: superjson,
        });
    });
}
